import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

export default function NotFound() {
  useEffect(() => {
    const prev = document.title;
    document.title = "Page not found (404) | Send-Proof";
    return () => { document.title = prev; };
  }, []);

  return (
    <div className="flex min-h-[100dvh] flex-col items-center justify-center bg-card px-5 text-center text-foreground" data-testid="notfound-page">
      <img src="/logo-mark.webp" alt="Send-Proof" className="h-14 w-14 rounded-xl" />
      <h1 className="mt-6 font-heading text-5xl font-extrabold tracking-tight">404</h1>
      <p className="mt-3 max-w-sm text-base text-muted-foreground">
        This page doesn't exist. Check the link, or head back to the punch lists.
      </p>
      <Button asChild className="mt-8 h-12 bg-emerald-500 px-6 text-base hover:bg-emerald-600" data-testid="notfound-home">
        <Link to="/"><Home className="mr-1 h-4 w-4" /> Back to home</Link>
      </Button>
    </div>
  );
}
